const toPositiveId = (value) => {
  const number = Number(value);
  return Number.isInteger(number) && number > 0 ? String(number) : "";
};

const userIdCandidates = (user) => [
  user?.emp_id,
  user?.empId,
  user?.worker_id,
  user?.workerId,
  user?.employee_id,
  user?.employeeId,
];

const userNameCandidates = (user) =>
  [
    user?.emp_name,
    user?.employee_name,
    user?.employeeName,
    user?.worker_name,
    user?.workerName,
    user?.user_name,
    user?.name,
  ]
    .map((value) => String(value || "").trim())
    .filter(Boolean);

export const resolveEmployeeId = ({ user, queryEmpId, employees = [] }) => {
  if (!employees.length) return "";
  const directId = [queryEmpId, ...userIdCandidates(user)]
    .map(toPositiveId)
    .find((id) => id && employees.some((employee) => toPositiveId(employee.emp_id) === id));

  if (directId) return directId;

  const accountMatches = employees.filter((employee) =>
    (toPositiveId(user?.user_no) && toPositiveId(employee.user_no) === toPositiveId(user.user_no)) ||
    (user?.login_id && employee.login_id === user.login_id)
  );
  if (accountMatches.length) return accountMatches.length === 1 ? toPositiveId(accountMatches[0].emp_id) : "";

  const names = userNameCandidates(user);
  if (!names.length || !employees.length) return "";

  const matches = employees.filter((employee) =>
    names.includes(String(employee.emp_name || "").trim())
  );

  return matches.length === 1 ? toPositiveId(matches[0].emp_id) : "";
};

export const getEmployeeName = ({ empId, employees = [], fallback = "" }) => {
  const id = toPositiveId(empId);
  const employee = employees.find((item) => String(item.emp_id) === id);
  return employee?.emp_name || fallback;
};
